<!--人才列表-->
<template>
  <div class="jobListBlock" :class="$IsMobile ? 'mobile' : ''">
    <div class="note">
      <h3>推荐人才</h3>
      <p>
        您正在浏览系统推荐人才，如需查看更多，请前往
        <el-link type="primary" @click="gotoEnterprise()">企业中心</el-link>
      </p>
    </div>

    <ul class="jobListMore">
      <div v-for="resume in resumeList" :key="resume.id">
        <li class="personnelInfo" @click="handleDetail(resume)">
          <div class="top">
            <img
              :src="
                require('@/pages/frontend/assets/images/' +
                  (resume.gender == MALE ? '' : 'wo') +
                  'man.png')
              "
              alt=""
            />
            <div class="jobInfo spaceBetween">
              <div class="left">
                <p class="tit">
                  <span class="position">{{ resume.username }}</span>
                  <span class="textInfo">
                    <span v-if="resume.jobStatus">{{
                      jobStatusFormat(resume.jobStatus)
                    }}</span>
                    <span v-if="resume.exp">{{ resume.exp }}</span>
                    <span v-if="resume.city">{{
                      cityFormatter(resume.city)
                    }}</span>
                  </span>
                </p>
                <p v-if="resume.expectPosition">
                  期望职能
                  <span
                    class="expectPosition"
                    v-html="expectPositionFormatter(resume.expectPosition)"
                  ></span>
                  <span>{{ rangeFormatter(resume) }}</span>
                </p>
                <p>技能勋章</p>
                <p class="tag">
                  <i
                    v-for="(item, index) in resume.skillMedalList"
                    :key="index"
                    >{{ item.labelName }}</i
                  >
                </p>
              </div>
              <div class="companyInfo">
                <p>简历关键词</p>
                <p class="tag">
                  <i v-for="item in resume.keywordList" :key="item.id">{{
                    item.labelName
                  }}</i>
                </p>
                <div class="bot">
                  <div class="dateTime">{{ resume.updateTime }} 发布</div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </div>
    </ul>
    <div class="pagination" v-if="page.totalElements">
      <span class="paginationTotal">共 {{ page.totalElements }} 条</span>
      <el-pagination
        v-if="!$IsMobile"
        @current-change="handleCurrentChange"
        :current-page.sync="searchParams.pageNumber"
        :page-size="searchParams.pageSize"
        layout="prev, pager, next, jumper"
        :total="page.totalElements"
      >
      </el-pagination>
      <el-pagination
        v-else
        @current-change="handleCurrentChange"
        :current-page.sync="searchParams.pageNumber"
        :page-size="searchParams.pageSize"
        background
        layout="prev, pager, next"
        :pager-count="5"
        small
        :total="page.totalElements"
      >
      </el-pagination>
    </div>
    <p class="emptyInfo" v-else>暂无内容</p>
  </div>
</template>
<script>
import { getTreeListByDictType } from "@/api/dict";

const MALE = 0; // 男
export default {
  data() {
    return {
      MALE: MALE,
      jobStatusOptions: [], // 求职状态
    };
  },
  computed: {
    /** 查询条件参数*/
    searchParams() {
      return this.$store.state.resume.searchParams;
    },
    /** 人才列表*/
    resumeList() {
      return this.$store.state.resume.resumeList;
    },
    page() {
      return this.$store.state.resume.page;
    },
  },
  created() {
    this.loadDictData();
    this.getResumeList();
  },
  methods: {
    loadDictData() {
      getTreeListByDictType("job_wanted_status").then((response) => {
        this.jobStatusOptions = response.data;
      });
    },
    /** 薪资范围格式化*/
    rangeFormatter(row) {
      return (
        row.willSalaryStart / 1000 + "-" + row.willSalaryEnd / 1000 + "K•月"
      );
    },
    handleCurrentChange(val) {
      this.searchParams.pageNumber = val;
      this.getResumeList();
    },
    /** 获取简历列表*/
    getResumeList() {
      this.$store.dispatch("resume/getResumeList");
    },
    // 打开简历详情
    handleDetail(resume) {
      if (resume && resume.id) {
        if (process.env.NODE_ENV == "development") {
          window.open(
            window.location.origin + "/frontend#/moreResume/detail/" + resume.id
          );
        } else {
          window.open(
            window.location.origin + "/#/moreResume/detail/" + resume.id
          );
        }
      }
    },
    // 求职状态
    jobStatusFormat(status) {
      let ret = this.dictFormatter(this.jobStatusOptions, status);
      return ret ? ret : "无";
    },
    expectPositionFormatter(data) {
      try {
        let position = JSON.parse(data);
        if (position instanceof Array && position.length > 0) {
          return position.join("&nbsp;&nbsp;");
        }
      } catch (e) {
        console.error("数据格式异常：", data);
      }
      return "";
    },
    cityFormatter(data) {
      try {
        data = JSON.parse(data);
        if (data instanceof Array && data.length > 0) {
          return data.join("");
        }
      } catch (e) {
        console.log(data);
        console.error(e);
      }
      return "地址不限";
    },
    /** 进入企业中心*/
    gotoEnterprise() {
      this.$store.commit("gotoEnterprise", {
        check: true,
        targetUri: "/backend#/index",
      });
    },
  },
};
</script>
<style scoped lang="scss">
.jobListBlock.mobile {
  .pagination {
    margin-top: 12px;
    font-size: 12px;
    padding: 12px;
    align-items: center;
    ::v-deep .el-pagination {
      .btn-prev,
      .btn-next,
      .el-pager {
        display: inline-block;
      }
      .el-pager li.btn-quicknext,
      .el-pager li.btn-quickprev {
        display: none;
      }
    }
  }
}
</style>
